import {Injectable} from '@angular/core';
import {AppContainerService, SideNavBarService} from '@mydocma/app-container';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {BehaviorSubject, firstValueFrom, map, switchMap} from 'rxjs';
import {MmRoutingService} from '../../../mm-routing/mm-routing.service';
import {MmPlanEditService} from '../mm-plan-view/services/mm-plan-edit.service';
import {ActivatedRoute} from '@angular/router';
import {routeToPath} from '../../../mm-routing/mm-routes.map';
import {MmRoutesEnum} from '../../../mm-routing/mm-routes.enum';
import {PlanEditModeEnum} from '../mm-plan-view/services/plan-edit-mode.enum';
import {SelectionService} from '@mydocma/component-library/src/lib/selection';
import {ViewFault} from '@docma-mm-core/fault/fault';
import {MmFaultsSplitService} from '../../mm-faults-view/services/mm-faults-split.service';
import {MmPlansManagerService} from './mm-plans-manager.service';
import {MmPlansFilterService} from './mm-plans-filter.service';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {MmFilterService} from '../../../mm-filter/mm-filter.service';


@UntilDestroy()
@Injectable()
export class MmPlanMobileViewService {

  private activatedSubject = new BehaviorSubject<boolean>(false);
  public activated$ = this.activatedSubject.asObservable();

  private fullScreenSubject = new BehaviorSubject<boolean>(false);
  public fullScreen$ = this.fullScreenSubject.asObservable();


  constructor(private readonly appContainerService: AppContainerService,
              private readonly routingService: MmRoutingService,
              private readonly plansManagerService: MmPlansManagerService,
              private readonly planEditService: MmPlanEditService,
              private readonly selectionService: SelectionService<ViewFault>,
              private readonly sideNavbarService: SideNavBarService,
              private readonly splitService: MmFaultsSplitService,
              public readonly plansFilterService: MmPlansFilterService,
              private readonly filterService: MmFilterService) {

    this.planEditService.planEditMode$
      .pipe(
        switchMap(ar => this.plansFilterService.filterdPlans$),
        switchMap(fp => this.plansFilterService.filteredPlansEditList$),
        switchMap(m => this.routingService.moduleActivatedRoute$),
        untilDestroyed(this))
      .subscribe(async ar => {
        await this.onRouteChanged(ar);
      });
  }

  // public setHeader(type: )

  public get activated(): boolean {
    return this.activatedSubject.value;
  }

  public get fullScreen(): boolean {
    return this.fullScreenSubject.value;
  }


  private async onRouteChanged(ar: ActivatedRoute) {

    const currentRoute = ar && this.routingService.getRoutePath(ar.snapshot);
    if (currentRoute && currentRoute === routeToPath.get(MmRoutesEnum.faults)) {
      (ar?.snapshot?.queryParams?.view === 'plan' || this.planEditService.planEditMode !== PlanEditModeEnum.None) &&
        this.appContainerService.isMobileView ?
        await this.activate() :
        this.deactivate();
    }
  }

  private async activate() {
    if (this.planEditService.planEditMode !== PlanEditModeEnum.None) {
      this.toggleFullscreen(true);
    } else {
      this.toggleFullscreen(false);
    }

    this.selectionService.stopSelectionMode();
    this.splitService.setRightViewVisble(true);

    if (!this.activated) {
      const currentStructure = (await firstValueFrom(this.filterService.state))?.structure;
      const filterdPlansOfStructure = await firstValueFrom(
        this.plansFilterService.filterdPlans$.pipe(
          map(m => m?.filter(plan =>
            plan?.loadState?.status === LoadStatusEnum.Loaded &&
            !!plan?.data?.Structure?.Id &&
            !!currentStructure?.Id &&
            plan.data.Structure.Id === currentStructure.Id
          ))
        )
      );

      if ((filterdPlansOfStructure?.length ?? 0) === 1) {
        this.plansManagerService.setSelectedPlan(filterdPlansOfStructure[0]);
        this.plansManagerService.setPlanFlyoutVisible(false);
      } else {
        if (this.planEditService.planEditMode === PlanEditModeEnum.None) {
          this.plansManagerService.setSelectedPlan(null);
          this.plansManagerService.setPlanFlyoutVisible(true);
        }
      }
    }

    this.activatedSubject.next(true);
  }

  private deactivate() {
    this.toggleFullscreen(false);
    if (this.activated) {
      this.splitService.setRightViewVisble(false);
    }
    this.activatedSubject.next(false);
  }

  private toggleFullscreen(fs: boolean) {
    this.appContainerService.headerVisible = !fs;
    this.sideNavbarService.barVisibility = !fs;
    this.fullScreenSubject.next(fs);

  }



}
